// extracted by mini-css-extract-plugin
export default {"card":"AuthCard_card__FN9Pu","cardCover":"AuthCard_cardCover__tYIiP","cardSubtitle":"AuthCard_cardSubtitle__pvd7Z","redirectSuggestion":"AuthCard_redirectSuggestion__UDgRS"};